module.exports = __webpack_public_path__ + "b963a23b47531c1e5f9de54b4c3bfaf0.MP3";